export const data = [
  {
    img: `${process.env.PUBLIC_URL}/img/223px-C_Sharp_logo.png`,
    name: 'C#',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/240px-.NET_Core_Logo.svg.png`,
    name: '.Net Core',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/iconfinder_187_Js_logo_logos_4373213.png`,
    name: 'Javascript',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/iconfinder_React.js_logo_1174949.png`,
    name: 'React',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/iconfinder_badge-html-5_317755.png`,
    name: 'HTML',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/iconfinder_badge-css-3_317756.png`,
    name: 'CSS',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/officedatabase_103574.png`,
    name: 'SQL',
  },
  {
    img: `${process.env.PUBLIC_URL}/img/iconfinder_social_media_social_media_logo_git_2993773.png`,
    name: 'Git',
  },
];
